import { Editor } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import { Toolbar } from 'copilot-design-system';
import React from 'react';

/**
 * This component is used to render the editor toobar when
 * the editor content is highlighted.
 * TODO: reuse this component in other places like NoteModal.tsx
 * @param tiptapEditor - The tiptap editor instance
 * @param enableNewEditorFormatter - Whether the new editor formatter is enabled
 * @returns The highlight toolbar component
 */
export const HighlightToolbar = React.forwardRef<
  HTMLDivElement,
  {
    tiptapEditor: Editor | null;
    overrideActions?: string[];
  }
>(
  (
    {
      tiptapEditor,
      overrideActions,
    }: {
      tiptapEditor: Editor | null;
      overrideActions?: string[];
    },
    ref,
  ) => {
    if (!tiptapEditor) return null;
    return (
      <BubbleMenu
        editor={tiptapEditor}
        tippyOptions={{ duration: 100, maxWidth: 'none' }}
      >
        <div ref={ref}>
          <Toolbar variant="highlight" overrideActions={overrideActions} />
        </div>
      </BubbleMenu>
    );
  },
);
